module.exports = __webpack_public_path__ + "img/brand-leader-id.412875c1.svg";